<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: String as PropType<
      "xxs" | "xs" | "sm" | "md" | "lg" | "xl"
    >,
    required: false,
    default: "md",
  },
})

const src = computed(() => {
  return "/celebrations/" + props.name + ".webm"
})
</script>

<template>
  <video
    :src="src"
    autoplay
    loop
    class="absolute bottom-11 left-1/2 z-20 -translate-x-1/2 transform"
    style="width: 200px; height: auto"
  ></video>
</template>
